module.exports = __webpack_public_path__ + "static/media/MTGimage.14346516.jpg";